exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-100{margin:0 auto;width:100%;padding-right:15px;padding-left:15px}.bg-01{background-color:#e0d8da}.pt-4{padding-top:2rem}#tabla-turnos{background:#df0a1c;-webkit-box-shadow:3px 3px 26px 2px rgba(0,0,0,.38);-moz-box-shadow:3px 3px 26px 2px rgba(0,0,0,.38);box-shadow:3px 3px 26px 2px rgba(0,0,0,.38);color:#fff;font-family:Prompt,sans-serif;line-height:1.3}.alert-llamado{padding:20px;margin-top:-10px;border:1px groove #ada5a5;border-radius:5px}.swal2-content{padding:0!important}.badge-red{background-color:#df0a1c;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00389a2e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/LcdTurnos.vue
// module id = 196
// module chunks = 0